import type { ReactNode } from "react";
import { AppSidebar } from "@/components/layouts/app-sidebar";
import { MainContent, PageContainer } from "@/components/layouts/page-layout";
import { Navbar } from "@/components/custom/navbar";
import type { SidebarMenuGroup } from "@/components/layouts/dashboard-nav-types";

export type {
  SidebarMenuButton,
  SidebarMenuGroup,
  SidebarMenuItem,
  SidebarMenuText,
} from "@/components/layouts/dashboard-nav-types";

export interface SidebarLayoutProps {
  menus: SidebarMenuGroup[];
  activePath?: string;
  children: ReactNode;
}

export function SidebarLayout({
  menus,
  activePath,
  children,
}: SidebarLayoutProps) {
  return (
    <>
      <AppSidebar menus={menus} activePath={activePath} />
      <main className="flex min-h-svh min-w-0 flex-1 flex-col bg-background">
        <Navbar />
        <MainContent>
          <PageContainer>{children}</PageContainer>
        </MainContent>
      </main>
    </>
  );
}
